<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white active">Features</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- Features Section Start-->
        <section class="section section-features bg-light">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="mb-3 wow fadeInUp" data-wow-duration="1.5s">
                            <h1 class="section-h1 font-weight-bold">
                                We Are Here To Help You
                            </h1>
                            <p class="text-left">
                                dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                                dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                            </p>
                            <hr class="hr-border">
                        </div>
                    </div>
                </div>
                <div class="features-main-block">
                    <div class="row">
                        <div class="col-md-6 col-lg-4">
                            <div class="mt-30 features-square wow fadeInUp" data-wow-duration="1.5s">
                                <div class="text-center">
                                    <span class="mdi mdi-stethoscope features-ico"></span>
                                    <h4 class="font-weight-bold text-center">Nephrologist Care</h4>
                                    <p> dolor sit amt, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="mt-30 features-square wow fadeInUp" data-wow-duration="1.5s">
                                <div class="text-center">
                                    <span class="mdi mdi-stethoscope features-ico"></span>
                                    <h4 class="font-weight-bold text-center">Eye Care</h4>
                                    <p class="plr-3"> dolor sit amt, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="mt-30 features-square wow fadeInUp" data-wow-duration="1.5s">
                                <div class="text-center">
                                    <span class="mdi mdi-stethoscope features-ico"></span>
                                    <h4 class="font-weight-bold text-center">Pediatrician Clinic</h4>
                                    <p> dolor sit amt, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="features-square wow fadeInUp" data-wow-duration="1.5s">
                                <div class="text-center">
                                    <span class="mdi mdi-stethoscope features-ico"></span>
                                    <h4 class="font-weight-bold text-center">Prenatal Care</h4>
                                    <p> dolor sit amt, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="features-square wow fadeInUp" data-wow-duration="1.5s">
                                <div class="text-center">
                                    <span class="mdi mdi-stethoscope features-ico"></span>
                                    <h4 class="font-weight-bold text-center">Advanced Technology</h4>
                                    <p> dolor sit amt, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="features-square wow fadeInUp" data-wow-duration="1.5s">
                                <div class="text-center">
                                    <span class="mdi mdi-stethoscope features-ico ico-circle bg-color-circle"></span>
                                    <h4 class="font-weight-bold text-center">Great Infrastructure</h4>
                                    <p> dolor sit amt, consectetur adipiscing elit. Phasellus blandit massa enim. Nullam id varius.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Features Section End-->
        <!-- Our Speciality Start-->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <h2 class="font-weight-bold">
                                Our Speciality
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-6">
                        <div class="mt-30 wow fadeIn" data-wow-delay="0.3s" data-wow-duration="1.5s">
                            <div class="row">
                                <div class="col-12">
                                    <a href="#" class="text-decoration-none">
                                        <img src="assets/images/features/features-1.jpg" class="img-fluid image-hover w-100" alt="">
                                    </a>
                                </div>
                                <div class="col-12">
                                    <h4 class="mb-0"><a href="#" class="f-title txt-black text-uppercase pt-2 d-block font-weight-bold text-decoration-none text-left font-weight-bold">Musketeers Surgical Team</a></h4>
                                    <p class="f-desc text-left"> dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non metus pulvinar.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="mt-30 wow fadeIn" data-wow-delay="0.6s" data-wow-duration="1.5s">
                            <div class="row">
                                <div class="col-12">
                                    <a href="#" class="text-decoration-none">
                                        <img src="assets/images/features/features-2.jpg" class="img-fluid image-hover w-100" alt="">
                                    </a>
                                </div>
                                <div class="col-12">
                                    <h4 class="mb-0"><a href="#" class="f-title txt-black text-uppercase pt-2 d-block font-weight-bold text-decoration-none text-left font-weight-bold">HEALTHCARE SOLUTIONS</a></h4>
                                    <p class="f-desc text-left"> dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non metus pulvinar.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="mt-30 wow fadeIn" data-wow-delay="0.9s" data-wow-duration="1.5s">
                            <div class="row">
                                <div class="col-12">
                                    <a href="#" class="text-decoration-none">
                                        <img src="assets/images/features/features-3.jpg" class="img-fluid image-hover w-100" alt="">
                                    </a>
                                </div>
                                <div class="col-12">
                                    <h4 class="mb-0"><a href="#" class="f-title txt-black text-uppercase pt-2 d-block font-weight-bold text-decoration-none text-left font-weight-bold">24/7 AVAILABILITY</a></h4>
                                    <p class="f-desc text-left"> dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non metus pulvinar.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Our Speciality Start-->
    </div>
</template>
<script>
    export default {
        name: "features",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            }

        }
    }</script>
